import { css } from 'react-emotion'

const styles = {
  wrapper: css({
    display: 'flex',
    width: '100%',
    placeContent: 'center space-between',
    paddingLeft: '16px',

    '& > p': {
      fontWeight: 'bold',
      fontSize: '1.1rem',
      color: 'rgba(0, 0, 0, 0.7)',
      textOverflow: 'ellipsis',
      wordBreak: 'keep-all',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    }
  }),
  button: css({
    marginLeft: '16px'
  })
}

export default styles



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/VideoHeader/VideoHeaderStyles.js